export const SignInRoutes = [
    {
        name: 'view',
        path: '/',
        component: () => import('./sign-in').then(m => m.default)
    }
];
